<template>
  <div>
    <step1 v-if="step==1" @nextStep="getStepInfo"></step1>
    <step2 v-if="step==2" :mobile="mobile"></step2>
  </div>

</template>
<script>
  import step1 from "../components/improve_info/step1"
  import step2 from "../components/improve_info/step2"
  export default {
    name : 'improveInfo',
    data () {
      return {
        step:1,
        mobile:''
      }
    },
    components : {
      'step1' : step1,
      'step2' : step2
    },
    methods:{
      getStepInfo:function(option){
        this.step=option.step;
        this.mobile=option.mobile;
      }
    }
  }
</script>
<style lang="less">

</style>



// WEBPACK FOOTER //
// src/view/improve_info.vue